import React from 'react'
import SolutionHero from './SolutionHero'
import SolutionSection1 from './SolutionSection1'
import ProcessSection from './ProcessSection'
import Faq from './Faq'
import TechStack from '../Home/TechStack'
import BookaCall from '../Home/BookaCall'

const Solutions = () => {
  return (
    <div>
        <SolutionHero/>
        <SolutionSection1/>
        <ProcessSection/>
        <Faq/>
        <TechStack/>
        <BookaCall/>
    </div>
  )
}

export default Solutions